var _line, _line2, _line3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBesparing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.92744,
    y1: 1.45503,
    x2: 8.92744,
    y2: 3.45366,
    stroke: "#222222",
    strokeWidth: 0.946679,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.8728,
    y1: 0.473339,
    x2: 11.8728,
    y2: 3.45374,
    stroke: "#222222",
    strokeWidth: 0.946679,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14.8181,
    y1: 1.45503,
    x2: 14.8181,
    y2: 3.45366,
    stroke: "#222222",
    strokeWidth: 0.946679,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8399 7.31997H11.5982C11.4074 7.31915 11.2222 7.38505 11.0747 7.50629C10.9272 7.62752 10.8268 7.79646 10.7907 7.98392C10.7546 8.17137 10.7851 8.36554 10.8769 8.53288C10.9688 8.70022 11.1162 8.83021 11.2938 8.90037L12.5541 9.40434C12.731 9.47478 12.8779 9.60467 12.9694 9.77168C13.0609 9.93869 13.0913 10.1324 13.0554 10.3194C13.0196 10.5064 12.9196 10.6751 12.7728 10.7964C12.626 10.9177 12.4415 10.984 12.2511 10.984H11.0079M11.9243 7.31997V6.43262M11.9243 11.7761V10.984",
    stroke: "#222222",
    strokeWidth: 0.946679,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3577 17.1949L15.9858 15.7164L16.0178 15.7075C16.2781 15.6505 16.5503 15.6901 16.7836 15.819C17.0168 15.9479 17.1951 16.1573 17.2853 16.4081C17.3755 16.6589 17.3713 16.9339 17.2735 17.1819C17.1757 17.4298 16.9911 17.6337 16.754 17.7554C7.71899 22.4334 10.0237 22.2219 0.600098 19.0827M7.72569 9.15215C7.72569 10.2657 8.16804 11.3336 8.95542 12.121C9.74279 12.9083 10.8107 13.3507 11.9242 13.3507C13.0377 13.3507 14.1057 12.9083 14.893 12.121C15.6804 11.3336 16.1228 10.2657 16.1228 9.15215C16.1228 8.03863 15.6804 6.97071 14.893 6.18334C14.1057 5.39596 13.0377 4.95361 11.9242 4.95361C10.8107 4.95361 9.74279 5.39596 8.95542 6.18334C8.16804 6.97071 7.72569 8.03863 7.72569 9.15215Z",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.60083 13.3505H2.23856C4.1421 13.3312 5.98868 13.9994 7.43908 15.2324L7.4696 15.2592H10.5217C10.8263 15.2584 11.1186 15.3786 11.3345 15.5934C11.5504 15.8082 11.6722 16.0999 11.673 16.4045C11.6738 16.709 11.5535 17.0014 11.3388 17.2173C11.124 17.4332 10.8322 17.5549 10.5277 17.5557L5.88696 17.5788",
    stroke: "#222222",
    strokeWidth: 1.09232,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBesparing);
export default __webpack_public_path__ + "static/media/besparing.8037f476d566b088add81f28d899563d.svg";
export { ForwardRef as ReactComponent };